
// Products
import ProductIndex from './components/Products/index.vue';
import ProductStats from './components/Products/stats.vue';
import ProductInactiveDates from './components/Products/inactive-dates.vue';

// Product Steps
import ProductStepper from './components/Products/create/stepper.vue';
import ProductCreate from './components/Products/create/product.vue';
import ProductOptions from './components/Products/create/options.vue';
import ProductExtra from './components/Products/create/extra.vue';
import ProductApprove from './components/Products/create/approve.vue';

// Options
import OptionIndex from './components/Options/index.vue';
import OptionStats from './components/Options/stats.vue';
import OptionStepper from './components/Options/create/stepper.vue';
import OptionCreate from './components/Options/create/option.vue';
import OptionPackaging from './components/Options/create/packaging.vue';

// Options Packaging Items
import PackagingItemIndex from './components/Options/create/packaging/index.vue';
import PackagingItemCreate from './components/Options/create/packaging/create.vue';

// Order
import OrderSearch from './components/Orders/search.vue';
import Order from './components/Orders/order.vue';

import Stats from './components/Stats/stats.vue';

// Coupon
import CouponIndex from './components/Coupons/index.vue';
import CouponCreate from './components/Coupons/create.vue';
import CouponStats from './components/Coupons/stats.vue';

//Tags
import TagIndex from './components/Tags/index.vue';
import TagCreate from './components/Tags/create.vue';
import DeliveryPointIndex from "../custom/components/DeliveryPoints";
import DeliveryPointCreate from "../custom/components/DeliveryPoints/create";


// Make Order Routes
import MakeOrderProductIndex from './components/MakeOrder/index';
import MakeOrderChoice from './components/MakeOrder/choice';
import {routes as makeOrderRoutes} from './../common/MakeOrder/routes';

// Productless Order Routes
import {routes as findProductlessOrderRoutes} from './../common/ProductlessOrder/OrderHandling/routes';
import {routes as makeProductlessOrderRoutes} from './../common/ProductlessOrder/OrderFlow/routes';


export const routes = [
    {path: '/', name:'home', redirect:'/order'},

    {path: '/product', name:'product.index', component:ProductIndex},
    {path: '/product/:product/stats', name:'product.stats', component:ProductStats},
    {path: '/product/:product/status', name:'product.status', component:ProductInactiveDates},

    {path: '/product/create', name:'product.create', component: ProductStepper, redirect:'/product/create/step/product', children:[
        {path: 'step/product', name:'product.create.product', component: ProductCreate},
    ]},

    {path: '/product/:product', name:'product.edit', component: ProductStepper, redirect:'/product/:product/step/product', children:[
        {path: 'step/product', name:'product.edit.product', component: ProductCreate},
        {path: 'step/options', name:'product.edit.options', component: ProductOptions},
        {path: 'step/extra', name:'product.edit.extra', component: ProductExtra},
        {path: 'step/approve', name:'product.edit.approve', component: ProductApprove},
    ]},

    {path: '/option', name:'option.index', component:OptionIndex},
    {path: '/option/:option/stats', name:'option.stats', component:OptionStats},

    {path: '/option/create', name:'option.create', component:OptionStepper, redirect:'/option/create/step/option', children: [
        {path: 'step/option', name: 'option.create.option', component: OptionCreate}
    ]},

    {path: '/option/:option/edit', name:'option.edit', component:OptionStepper, redirect:'/option/:option/edit/step/option', children: [
        {path: 'step/option', name: 'option.edit.option', component: OptionCreate},
        {path: 'step/packaging', name: 'option.edit.packaging', component: OptionPackaging, redirect:'/option/:option/edit/step/packaging/index', children:[
            {path: 'index', name: 'option.edit.packaging.index', component: PackagingItemIndex},
            {path: 'create', name: 'option.edit.packaging.create', component: PackagingItemCreate},
            {path: 'edit/:item', name: 'option.edit.packaging.edit', component: PackagingItemCreate},
        ]}
    ]},

    //{path: '/option/create', name:'option.create', component:OptionCreate},
    //{path: '/option/:option/edit', name:'option.edit', component:OptionCreate},

    {path: '/order/search', name:'order.search', component:OrderSearch},
    {path: '/order/search/:order', name:'order.search.order', component:OrderSearch},
    {path: '/order', name:'order', component:Order},

    {path: '/stats', name:'stats', component:Stats},

    {path: '/coupon', name:'coupon.index', component:CouponIndex},
    {path: '/coupon/create', name:'coupon.create', component:CouponCreate},
    {path: '/coupon/:coupon/stats', name:'coupon.stats', component:CouponStats},
    {path: '/coupon/:coupon/edit', name:'coupon.edit', component:CouponCreate},

    {path: '/deliveryPoint', name:'deliveryPoint.index', component:DeliveryPointIndex},
    {path: '/deliveryPoint/create', name:'deliveryPoint.create', component:DeliveryPointCreate},
    {path: '/deliveryPoint/:point/edit', name:'deliveryPoint.edit', component:DeliveryPointCreate},

    {path: '/tag', name:'tag.index', component:TagIndex},
    {path: '/tag/create', name:'tag.create', component:TagCreate},
    {path: '/tag/:tag/edit', name:'tag.edit', component:TagCreate},

    {path: '/make-order', name:'make-order', component: MakeOrderProductIndex},
    {path: '/make-order/choice', name:'make-order-choice', component: MakeOrderChoice},

    ...makeOrderRoutes,

    ...findProductlessOrderRoutes,
    ...makeProductlessOrderRoutes,


];
